export default __webpack_public_path__ + "static/media/cognovi-logo.293b6380.png";